(function () {
  'use strict';

  function init() {
    loadCrossSell();

    document.addEventListener('theme:cart:loaded', function () {
      document.querySelector('[data-cart-cross-sell]')?.classList.add('loading');
      loadCrossSell();
    });
  }

  async function loadCrossSell() {
    try {
      let crossSellDiv = document.querySelector('[data-cart-cross-sell]');
      if (!crossSellDiv) {
        crossSellDiv = document.createElement('div');
        crossSellDiv.className = 'cart-drawer__cross-sell loading';
        crossSellDiv.setAttribute('data-cart-cross-sell', '');
        const cartDrawer = document.querySelector('.cart-drawer');
        if (window.innerWidth <= 768) {
          cartDrawer?.querySelector('.cart-drawer__items')?.append(crossSellDiv);
        } else {
          cartDrawer?.appendChild(crossSellDiv);
        }
      } else if (window.innerWidth <= 768) {
        document.querySelector('.cart-drawer__items')?.append(crossSellDiv);
      }

      const response = await fetch(`${window.theme.routes.root}?section_id=cart-cross-sell`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const apiContent = doc.querySelector('.cart-drawer__cross-sell--container');
      crossSellDiv.innerHTML = apiContent.innerHTML;
      crossSellDiv.classList.remove('loading');
      if (doc.querySelectorAll('.cart-drawer__cross-sell__item').length === 0) {
        crossSellDiv.style.display = 'none';
      } else {
        crossSellDiv.style.display = '';
      }
    } catch (error) {
      console.error('Error loading cross-sell:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
